import { ShoppingContext } from '../../../data/model';
import {
  ButtonClickEventData,
  CartEventData,
  CheckoutEventData,
  CheckoutOptionEventData,
  EventData,
  ITrackingService,
  LinkClickEventData,
  ProductData,
  PurchaseEventData,
} from '../TrackingService';
import { HubSpotQueue } from './HubSpotQueue';

export class HubSpotTrackingService implements ITrackingService {
  private static skipFirstPageVisitTracking = true;

  private queue = new HubSpotQueue();

  trackPageVisit(relativeUrl: string): void {
    // Avoid duplicated views tracking, see notes here - https://developers.hubspot.com/docs/methods/tracking_code_api/track_page_view
    if (HubSpotTrackingService.skipFirstPageVisitTracking) {
      HubSpotTrackingService.skipFirstPageVisitTracking = false;
      return;
    }

    this.queue.pushData(['setPath', relativeUrl]);
    this.queue.pushData(['trackPageView']);
  }

  trackAddToCart(data: CartEventData): void {
    data.products.forEach((x) => {
      const args = this.buildProductEventArgs('addToCart', data.context, x);
      this.trackEvent(args);
    });
  }

  trackRemoveFromCart(data: CartEventData): void {
    data.products.forEach((x) => {
      const args = this.buildProductEventArgs('removeFromCart', data.context, x);
      this.trackEvent(args);
    });
  }

  trackButtonClick(data: ButtonClickEventData): void {
    this.trackClickEvent(data.buttonName);
  }

  trackDownload(data: LinkClickEventData): void {
    if (!data.name) {
      return;
    }

    this.trackClickEvent(data.name);
  }

  trackCheckoutStep(data: CheckoutEventData): void {
    const args = {
      id: 'checkoutStep',
      step: data.stepId,
    };
    this.trackEvent(args);
  }

  trackCheckoutOption(data: CheckoutOptionEventData): void {
    return;
  }

  trackCheckoutCompleted(data: PurchaseEventData): void {
    const args = {
      id: 'checkoutCompleted',
      orderNumber: data.orderNumber,
      revenue: data.revenue,
      tax: data.tax,
      shipping: data.shipping,
      currency: data.context.currencyCode,
    };
    this.trackEvent(args);
  }

  trackAskForPriceCompleted(data: EventData): void {
    this.trackClickEvent('askForPriceFormSubmitted');
  }

  private buildProductEventArgs(id: string, context: ShoppingContext, product: ProductData) {
    return {
      id: id,
      productId: product.id,
      productName: product.name,
      brandName: product.brand,
      price: product.price,
      currency: context.currencyCode,
      quantity: product.quantity,
    };
  }

  private buildClickEventArgs(id: string) {
    return { id: id };
  }

  private trackClickEvent(eventName: string) {
    const args = this.buildClickEventArgs(eventName);
    this.trackEvent(args);
  }

  private trackEvent(args: {}) {
    this.queue.pushData(['trackEvent', args]);
  }
}
